<template>
    <div>
        <div class="top-bar-box">
            <div class="top-bar" v-for="(item, index) in barList" :key="item.id" @click="selBar(item)">
                <div class="top-bar-title" :class="[item.ischeck ? 'is-sel' : 'no-sel']" :style="index == 1 && barType == 'ls' && isQuan > 0 ? 'margin-left: 31px;': ''">{{ item.name }}
								</div>
                <div class="top-bar-line" :class="[item.ischeck ? 'is-line-sel' : 'no-line-sel']"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
		props: {
			barList: Array,
			barType: {
				type: String,
				default: '',
			},
			isQuan: {
				type: Number,
				default: 0,
			},
		},
    data() {
        return {
        };
    },
	methods: {
		goSysc() {
			this.$router.push({
				name: 'show-pdf'
			})
		},
		selBar(e) {
			for(let i in this.barList) {
				if(e.id == this.barList[i].id) {
					this.barList[i].ischeck = true
				} else {
					this.barList[i].ischeck = false
				}
			}
			this.$emit('parentData', e.id)
		}
	}
}
</script>
<style scoped>
.top-bar-box {
	width: 100%;
	height: 44px;
	background: #fff;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
	font-size: 15px;
	position: relative;
}
.sysc {
	width: 24px;
	height: 26px;
	position: absolute;
	right: 10px;
}
.xgz {
	position: absolute;
  background: red;
  font-size: 12px;
  z-index: 1;
  color: #fff;
  top: -9px;
  left: -20px;
  padding: 0 5px;
  border-radius: 10px;
}
.top-bar {
	width: 100%;
	height: 44px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.top-bar-title {
	height: 41px;
	line-height: 41px;
}
.top-bar-line {
	width: 24px;
	height: 3px;
	border-radius: 10px;
}
.is-sel {
	color: #333333;
}
.no-sel {
	color: #9A9B9E;
}

.is-line-sel {
	background: #4873C0;
	animation: fadein 0.5s;
}
.no-line-sel {
	background: #fff;
	animation: fadeout 0.5s;
}
@keyframes fadeout {
    /*设置内容由显示变为隐藏*/
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
@keyframes fadein {
    /*设置内容由隐藏变为显示*/
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
